import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import { useStateContext } from "contexts/ContextProvider";
import RequireAuth from "./contexts/RequireAuth";
import "./App.css";
import {
  AdminDashboard,
  Data,
  SchoolDashboard,
  Form,
  IABIDE,
  IABIDEDASHBOARD,
  IABIDESCHOOLDASHBOARD,
  GradeLevels,
  Landing,
  Login,
  Competencies,
  KSASubjects,
  Missing,
  Offices,
  OfficeTypes,
  Subjects,
  Components,
  Unauthorized,
  Users,
  Directories,
  Subdirectories,
  Submissions,
  Posts,
  RejectedSubmissions,
} from "./pages";
import SMEALayout from "./layout/smea/SMEALayout";
import IAbideAdminLayout from "./layout/i-abide/IAbideAdminLayout";
import useRefreshToken from "./contexts/interceptors/useRefreshToken";

function App() {
  const { auth } = useStateContext();
  const refresh = useRefreshToken();
  // const navigate = useNavigate();
  // const location = useLocation();

  const multirole = [
    "teacher",
    "school head",
    "school non-teaching personnel",
    "admin",
    "sgod - section head",
    "sgod - unit head",
    "sgod - chief",
    "education program supervisor",
    "cid - chief",
    "oasds",
    "osds",
    "administrative officer 2",
    "administrative officer 4",
    "administrative officer 5",
    "project development officer 1",
    "project development officer 2",
    "education program specialist 2",
    "senior education program specialist",
    "chief education supervisor",
    "accountant 3",
  ];

  const rolesExceptTeacher = [
    "admin",

    "school head",
    "sgod - section head",
    "sgod - unit head",
    "sgod - chief",
    "education program supervisor",
    "cid - chief",
    "oasds",
    "osds",
    "administrative officer 2",
    "administrative officer 4",
    "administrative officer 5",
    "project development officer 1",
    "project development officer 2",
    "education program specialist 2",
    "senior education program specialist",
    "chief education supervisor",
    "accountant 3",
  ];

  useEffect(() => {
    if (!auth) {
      refresh();
    }
  }, []);

  // function checkRefreshTokenInCookie() {
  //   const cookies = document.cookie.split("; ");
  //   // eslint-disable-next-line no-restricted-syntax
  //   for (const cookie of cookies) {
  //     // eslint-disable-next-line no-unused-vars
  //     const [name, value] = cookie.split("=");
  //     if (name === "refreshToken") {
  //       return true; // Refresh token exists in the cookie
  //     }
  //   }
  //   return false; // Refresh token does not exist in the cookie
  // }

  // useEffect(() => {
  //   const refreshTokenExists = checkRefreshTokenInCookie();
  //   // if (!refreshTokenExists) {
  //   //   console.log(refreshTokenExists);
  //   // }

  //   console.log(refreshTokenExists);
  //   if (sessionExpired) {
  //     alert("Session has expired. Please log in again");
  //     navigate("/login", { state: { from: location }, replace: true });
  //   }
  // }, [sessionExpired]);

  return (
    <Box>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route element={<RequireAuth allowedRoles={multirole} />}>
          <Route path="/" element={<Landing />} />
          <Route path="/i-abide" element={<IABIDE />} />
          <Route path="/" element={<IAbideAdminLayout />}>
            <Route path="/posts" element={<Posts />} />
            <Route path="/submissions" element={<Submissions />} />
            <Route path="/rejects" element={<RejectedSubmissions />} />
          </Route>
          <Route path="/" element={<SMEALayout />}>
            <Route path="/data" element={<Data />} />
            <Route path="/competencies" element={<Competencies />} />
          </Route>

          <Route
            element={<RequireAuth allowedRoles={["teacher", "school head"]} />}
          >
            {/* <Route path="/" element={<IAbideAdminLayout />}>
          </Route> */}
            <Route path="/" element={<SMEALayout />}>
              <Route path="/school-dashboard" element={<SchoolDashboard />} />
              <Route path="/form" element={<Form />} />
            </Route>
          </Route>

          <Route
            element={
              <RequireAuth
                allowedRoles={[
                  "teacher",
                  "school head",
                  "school non-teaching personnel",
                ]}
              />
            }
          >
            <Route path="/" element={<IAbideAdminLayout />}>
              <Route
                path="/iabide-school-dashboard"
                element={<IABIDESCHOOLDASHBOARD />}
              />
              <Route path="/documents" element={<IABIDESCHOOLDASHBOARD />} />
              {/* <Route path="/submissions" element={<IABIDESCHOOLDASHBOARD />} /> */}
            </Route>
          </Route>

          <Route element={<RequireAuth allowedRoles={rolesExceptTeacher} />}>
            <Route path="/" element={<IAbideAdminLayout />}>
              <Route path="/i-abide-dashboard" element={<IABIDEDASHBOARD />} />
              <Route path="/directories" element={<Directories />} />
              <Route path="/subdirectories" element={<Subdirectories />} />
            </Route>

            <Route path="/" element={<SMEALayout />}>
              <Route path="/dashboard" element={<AdminDashboard />} />
              <Route path="/gradelevels" element={<GradeLevels />} />
              <Route path="/offices" element={<Offices />} />
              <Route path="/officeTypes" element={<OfficeTypes />} />
              <Route path="/subjects" element={<Subjects />} />
              <Route path="/components" element={<Components />} />
              <Route path="/ksa-subjects" element={<KSASubjects />} />
              <Route path="/users" element={<Users />} />
            </Route>
          </Route>
        </Route>
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="*" element={<Missing />} />
      </Routes>
    </Box>
  );
}

export default App;
